/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable consistent-return */
/* eslint-disable react/destructuring-assignment */
import React from "react";
import LoadingGit from "../../assets/images/loading.gif";

export default class Component extends React.Component {
  // 必要なprops

  render = () => {
    // eslint-disable-next-line react/destructuring-assignment
    const className = this.props.className
      ? this.props.className + (this.props.isOpen ? "show" : "hide")
      : `loading ${this.props.isOpen ? "show" : "hide"}`;
    return (
      <div className={className}>
        <img src={LoadingGit} alt="Loading..." />
      </div>
    );
  };
}
